<ct-lib-confirm-modal
  #modal
  [label]="'company-tool.snippets.invoice-booking.title' | transloco"
  [confirmLabel]="'company-tool.snippets.invoice-booking.confirm' | transloco"
  [cancelLabel]="'company-tool.snippets.invoice-booking.cancel' | transloco"
  (onConfirm)="confirmed.emit()"
  (onCancel)="dismissed.emit()"
>
  <p>
    {{ 'company-tool.snippets.invoice-booking.intro' | transloco }}
  </p>
  <ul class="lines">
    @for (line of lines(); track line.name) {
      <li>
        <span>{{ line.name }}</span>
        <strong>{{ line.priceLabel }}</strong>
      </li>
    }
  </ul>
  @if (intervalLabel(); as interval) {
    <p class="interval">{{ interval }}</p>
  }
  <div class="total">
    <span>{{ 'company-tool.snippets.invoice-booking.total' | transloco }}</span>
    <strong>{{ totalLabel() }}</strong>
  </div>
  <p class="vat-note">
    {{ 'company-tool.snippets.invoice-booking.vat-note' | transloco }}
  </p>
  @if (showProrationHint()) {
    <ct-lib-info-banner type="info" class="proration-hint" role="status">
      <p>
        {{ 'company-tool.snippets.invoice-booking.proration-hint' | transloco }}
      </p>
    </ct-lib-info-banner>
  }
  <p class="note">
    {{ 'company-tool.snippets.invoice-booking.invoice-note' | transloco }}
  </p>
</ct-lib-confirm-modal>
